import { Controller } from "@hotwired/stimulus";

const MAX_PAGE_AGE_MILLISECONDS = 60000;

export default class extends Controller {
  static values = {
    data: Array,
    layout: Object,
  };

  connect() {
    Plotly.newPlot(this.element, this.dataValue, this.layoutValue, {
      locale: "NL",
      responsive: true,
      displaylogo: false,
      displayModeBar: false,
    });

    this.refreshPageIfStale = this.refreshPageIfStale.bind(this);
    this.pageLoadedAt = Date.now();
    setTimeout(this.refreshPageIfStale, MAX_PAGE_AGE_MILLISECONDS);
    document.addEventListener("visibilitychange", this.refreshPageIfStale);
  }

  refreshPageIfStale() {
    if (Date.now() - this.pageLoadedAt > MAX_PAGE_AGE_MILLISECONDS) {
      window.location.reload();
    }
  }
}
